import { render, staticRenderFns } from "./BatchGroupModal.vue?vue&type=template&id=1b1e8caf&scoped=true&"
import script from "./BatchGroupModal.vue?vue&type=script&lang=js&"
export * from "./BatchGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchGroupModal.vue?vue&type=style&index=0&id=1b1e8caf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1e8caf",
  null
  
)

export default component.exports